import * as React from 'react';
import Head from 'next/head';

import { SITE_TITLE } from '@src/config/constants';
import { AboutGetStarted } from '@src/routes/about/components/AboutGetStarted';
import { AboutIntro } from '@src/routes/about/components/AboutIntro';
import { AboutOffenders } from '@src/routes/about/components/AboutOffenders';
import { AboutPeople } from '@src/routes/about/components/AboutPeople';
import { AboutPhotosSimran } from '@src/routes/about/components/AboutPhotosSimran';
import { AboutRecommendations } from '@src/routes/about/components/AboutRecommendations';
import { AboutTheTeam } from '@src/routes/about/components/AboutTheTeam';

import styles from './about-us.module.css';

export interface AboutUsProps {}

/**
 * @name AboutUs
 * @description Simple about page
 */
export const AboutUs = (_props: AboutUsProps) => {
  return (
    <>
      <Head>
        <title>{`About Us | ${SITE_TITLE}`}</title>
      </Head>

      <main className={styles.component}>
        <AboutIntro />
        <AboutPhotosSimran />
        <AboutTheTeam />
        <AboutOffenders className="ui-border-top" />
        <AboutRecommendations className="ui-border-top" />
        <AboutPeople className="ui-border-top" />
        <AboutGetStarted />
      </main>
    </>
  );
};

export default AboutUs;
